import { FC, useState } from "react"
import { toast } from "react-toastify"

import { Modal } from "components/modals/Modal"

import { TournamentService } from "services/tournaments/tournament.service"

import { PointRule } from "types/tournament.types"

interface SavePresetModalProps {
  open: boolean
  rules: PointRule[]
  onClose: () => void
  onSaved: () => void
}

export const SavePresetModal: FC<SavePresetModalProps> = ({ open, rules, onClose, onSaved }) => {
  const [name, setName] = useState("")
  const [description, setDescription] = useState("")

  const handleSave = async () => {
    if (!name.trim()) {
      toast.error("Preset name is required")
      return
    }

    try {
      await TournamentService.createPreset({
        name: name.trim(),
        description: description.trim() || undefined,
        rules
      })
      toast.success("Preset saved!")
      onSaved()
    } catch {
      toast.error("Failed to save preset")
    }
  }

  return (
    <Modal open={open} handler={onClose}>
      <div className="bg-white dark:bg-gray-800 rounded-lg p-6 w-full max-w-md shadow-xl">
        <h3 className="text-lg font-semibold text-gray-900 dark:text-white mb-4">Save as Preset</h3>
        <div className="space-y-3">
          <div>
            <label className="text-sm text-gray-700 dark:text-gray-300">Preset Name *</label>
            <input
              type="text"
              value={name}
              onChange={(e) => setName(e.target.value)}
              className="w-full px-3 py-2 border rounded dark:bg-gray-700 dark:border-gray-600 dark:text-white"
              placeholder="e.g., Standard Casino Rules"
            />
          </div>
          <div>
            <label className="text-sm text-gray-700 dark:text-gray-300">Description</label>
            <textarea
              value={description}
              onChange={(e) => setDescription(e.target.value)}
              className="w-full px-3 py-2 border rounded dark:bg-gray-700 dark:border-gray-600 dark:text-white"
              placeholder="Optional description..."
              rows={2}
            />
          </div>
          <div className="text-xs text-gray-500 dark:text-gray-400">
            Saving {rules.length} rule{rules.length !== 1 ? "s" : ""} as a reusable preset
          </div>
        </div>
        <div className="flex justify-end gap-3 mt-4">
          <button type="button" onClick={onClose} className="px-4 py-2 text-sm border rounded dark:border-gray-600 dark:text-gray-300">
            Cancel
          </button>
          <button
            type="button"
            onClick={handleSave}
            className="px-4 py-2 text-sm bg-[rgba(169,78,206,1)] text-white rounded hover:bg-[rgba(169,78,206,0.8)]"
          >
            Save Preset
          </button>
        </div>
      </div>
    </Modal>
  )
}
